import { COMPONENT_TYPE } from '@abiglobalhealth/go-types'
import { Alert } from '@components/Alert'
import { ButtonComponent } from '@components/ButtonComponent'
import { CheckboxGroup } from '@components/CheckboxGroup'
import { CountrySelect } from '@components/CountrySelect'
import { Image } from '@components/Image'
import { Input } from '@components/Input'
import { PhoneNumber } from '@components/PhoneNumber'
import { RadioGroup } from '@components/RadioGroup'
import { Row } from '@components/Row'
import { SelectComponent } from '@components/SelectComponent'
import { SurveyChoices } from '@components/SurveyChoices'
import { Text } from '@components/Text'
import { Video } from '@components/Video'
import React from 'react'

export const COMPONENTS: Record<COMPONENT_TYPE, (props: any) => React.JSX.Element | null> = {
  [COMPONENT_TYPE.TEXT]: Text,
  [COMPONENT_TYPE.BUTTON]: ButtonComponent,
  [COMPONENT_TYPE.INPUT]: Input,
  [COMPONENT_TYPE.IMAGE]: Image,
  [COMPONENT_TYPE.RADIO_GROUP]: RadioGroup,
  [COMPONENT_TYPE.VIDEO]: Video,
  [COMPONENT_TYPE.SELECT]: SelectComponent,
  [COMPONENT_TYPE.PHONE_NUMBER]: PhoneNumber,
  [COMPONENT_TYPE.COUNTRY_SELECT]: CountrySelect,
  [COMPONENT_TYPE.CHECKBOX_GROUP]: CheckboxGroup,
  [COMPONENT_TYPE.ALERT]: Alert,
  [COMPONENT_TYPE.ROW]: Row,
  [COMPONENT_TYPE.SURVEY_CHOICES]: SurveyChoices
}
